// authSaga.js
import { call, put, takeLatest } from 'redux-saga/effects';


 // wherever your socket is initialized
 // abstract navigation helper
import socket from '../../utils/Socket';
import Axios from '../../utils/Axios';
import { LOGIN_FAILURE, LOGIN_REQUEST, LOGIN_SUCCESS } from '../Actions/Actions';
import { navigate } from '../../utils/navigation';
import { AUTH_LOGIN, GET_NOTIFICATION } from '../../config/API_Collection';
import ERROR_MESSAGES, { getErrorMessage } from '../../config/Error_Codes';
import { fetchAndBuildPermissions } from '../../config/Permission_List';



function* loginSaga(action) {
  try {
    const { username, password } = action.payload;
    const payload = { username, password };


    const response = yield call(Axios.post, AUTH_LOGIN, payload);
    const data = response.data.data;
    const token = data.auth_key;
    const profile_data = data.profile_data;

    console.log(response);
    

    // Store user data
    localStorage.setItem('authToken', token);
    localStorage.setItem('userData', JSON.stringify(profile_data));
    localStorage.setItem('userDetails', JSON.stringify(data));

    // Optional: Fetch notifications
    try {
      // const notiResponse = yield call(Axios.get, GET_NOTIFICATION);
      // const notifications = notiResponse.data.data;
      // localStorage.setItem('notifications', JSON.stringify(notifications));
    } catch (e) {
      // silently fail
    }

    // Socket register
    if (profile_data.user_token) {
      socket.emit('register', profile_data.user_token);
      socket.emit('join_global');
      console.log('Socket connected with token:', profile_data.user_token);
    }

        const permissions = yield call(fetchAndBuildPermissions, response.data.data.actions);
 localStorage.setItem("builtPermissionsV1", JSON.stringify(permissions));

    // Dispatch success and navigate
    yield put({type:LOGIN_SUCCESS,payload:{profile_data:profile_data,actions:permissions}});
    navigate('/dashboard'); 
  } catch (error) {
    const status = error.response?.status;
    let errorMsg = 'An unexpected error occurred! Please try again.';
    if (status === 401) {errorMsg = getErrorMessage(status)}
    console.warn(errorMsg);
    
    yield put({type:LOGIN_FAILURE,payload:errorMsg});
  }
}

export default function* authWatcher() {
  yield takeLatest(LOGIN_REQUEST, loginSaga);
}
